import { Injectable } from '@angular/core';
import { TranslateDefaultParser } from '@ngx-translate/core';
import { tenantMessage, tenantText } from './tenant-message';

/** Resolve catalog-backed presentation copy before ngx-translate interpolates its regular parameters. */
@Injectable()
export class TenantTranslateParser extends TranslateDefaultParser {
    override interpolate(
        expression: Parameters<TranslateDefaultParser['interpolate']>[0],
        parameters?: Parameters<TranslateDefaultParser['interpolate']>[1]
    ): string | undefined {
        const resolved =
            typeof expression === 'string'
                ? expression.startsWith('@tenant:')
                    ? tenantMessage(expression.slice('@tenant:'.length))
                    : tenantText(expression)
                : expression;
        return super.interpolate(resolved, parameters);
    }
}
